"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgOutageWarning(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M22.467 5.414c-1.078-1.93-3.855-1.93-4.934 0L3.35 30.795C2.297 32.68 3.659 35 5.817 35h28.367c2.157 0 3.52-2.32 2.466-4.204L22.467 5.413z", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M20 15v8", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M21 27a1 1 0 10-2 0h2zm-2 1a1 1 0 102 0h-2zm0-1v1h2v-1h-2z", fill: "currentColor" }, void 0)] }), void 0));
}
exports.default = SvgOutageWarning;
//# sourceMappingURL=OutageWarning.js.map